import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCxL9iK76DX_r7HRq2rgutbo1uKoz2dpHc",
  authDomain: "data-revival.firebaseapp.com",
  projectId: "data-revival",
  storageBucket: "data-revival.firebasestorage.app",
  messagingSenderId: "773603974823",
  appId: "1:773603974823:web:e3a3d32f08cc1a336ec582",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
